import type { SVGProps } from "react";
import * as React from "react";

const SvgCallRouting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.155 17.159h-3.81a1 1 0 0 1-1-1V4.306m4.81 4.5h-3.81m3.922-2.778h8.388v4.778h-8.388V6.028m0 8.778h8.388v4.888h-8.388z"
    />
  </svg>
);
export default SvgCallRouting;
